import Vue from 'vue'
import Demo from './Demo.vue'

new Vue({
  render: h => h(Demo)
}).$mount('#app')
